// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Fuhrparkeintrag } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteFuhrparkeintrag(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string
) => Promise<Fuhrparkeintrag> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId) =>
      (await getAPI()).fuhrparkeintraege.deleteFuhrparkeintrag({
        taetigkeitsberichtId,
        fuhrparkeintragId,
      }),
    [getAPI]
  );
}
